import React from 'react';
import PropTypes from 'prop-types';
import { trackElement, trackEvent } from '@nexus/fff-analytics';

import Timeline from '../Timeline';
import CollapsiblePanel from '../CollapsiblePanel';
import './SeasonalTimeline.css';

const SeasonalTimeline = ({
  isExpired, isNotSubscribed, data: { timelineSteps, accountPlan }, screenMode,
}) => (
  <section className="seasonal-timeline">
    <div className="seasonal-timeline__container">
      <CollapsiblePanel title="SEASONAL TIMELINE" screenMode={screenMode}>
        <>
          <div className="seasonal-timeline__timeline__buttons">
            <div className="seasonal-timeline__timeline">
              <Timeline nodeBoxes={timelineSteps} />
            </div>
            <div className="seasonal-timeline__buttons">
              {isNotSubscribed && <a className="fff-btn-primary" href="/activate-membership">ACTIVATE MEMBERSHIP</a>}
              {/* eslint-disable no-nested-ternary */}
              {isExpired && !isNotSubscribed
                ? (<a className="fff-btn-primary" href="/reactivate-my-membership">REACTIVATE</a>)
                : (accountPlan === 'ANNUAL' && !isNotSubscribed ? (
                  <a
                    className="fff-btn-primary"
                    href="/invite-friends"
                    onClick={() => trackEvent('GIFT A BOX')}
                  >
                    GIFT A BOX
                  </a>
                ) : (!isNotSubscribed && (
                <a
                  className="fff-btn-primary"
                  href="/upgrade-confirmation"
                  onClick={() => trackEvent('UPGRADE TO ANNUAL')}
                >
                  UPGRADE TO ANNUAL
                </a>
                )))}
              <a
                className="fff-btn-primary-black-outline"
                onClick={() => trackElement('ADD TO CALENDAR')}
                href="https://support.fabfitfun.com/hc/en-us/articles/360052444092/"
                target="_blank"
                rel="noreferrer"
              >
                ADD TO CALENDAR
              </a>
            </div>
          </div>
          <div className="divider" />
        </>
      </CollapsiblePanel>
    </div>
  </section>
);

SeasonalTimeline.defaultProps = {
  data: {},
  screenMode: 'mobile',
  isExpired: false,
  isNotSubscribed: false,
};

SeasonalTimeline.propTypes = {
  screenMode: PropTypes.string,
  data: PropTypes.shape({
    accountPlan: PropTypes.string,
    currentTimelineSteps: PropTypes.arrayOf(PropTypes.string),
    timelineSteps: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      message: PropTypes.string,
      order: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      date: PropTypes.string,
      group: PropTypes.string,
    })),
  }),
  isExpired: PropTypes.bool,
  isNotSubscribed: PropTypes.bool,
};

export default SeasonalTimeline;
